// src/config/apiConfig.js

// --- Backend Configuration ---
// Set this to true to use the local backend, false for the AWS backend.
export const USE_LOCAL_BACKEND = false; // USE AWS BACKEND

// Import sensitive configuration
let sensitiveConfig = {};

// In browser environment, we'll load from window.secrets if available
if (typeof window !== 'undefined' && window.secrets) {
  sensitiveConfig = window.secrets;
} else {
  try {
    // Try to load from src/config first (development)
    sensitiveConfig = require('./secrets');
  } catch (error) {
    console.warn('❌ Sensitive config not found, using environment variables or defaults');
    console.error('Error details:', error);
    sensitiveConfig = {};
  }
}

export const LOCAL_API_BASE_URL = sensitiveConfig.LOCAL_API_BASE_URL || 'http://localhost:5000/api';
export const AWS_API_BASE_URL = sensitiveConfig.AWS_API_BASE_URL || process.env.REACT_APP_AWS_API_BASE_URL || 'https://joxb5xoz4l.execute-api.us-east-2.amazonaws.com/dev/api';


/**
 * Returns the appropriate API base URL based on the USE_LOCAL_BACKEND setting.
 * @returns {string} The API base URL.
 */
export const getApiBaseUrl = () => {
  const result = USE_LOCAL_BACKEND ? LOCAL_API_BASE_URL : AWS_API_BASE_URL;
  return result;
};

// You can also export the determined apiBaseUrl directly if you prefer not to call a function everywhere
export const API_BASE_URL = getApiBaseUrl();